import React, { useEffect, useState } from "react";
import { Subscription } from "rxjs";
import { ArService } from "../../utilities/arService";
import MenuItemService from "../../utilities/menuItemService";
import MenuItem from "../navMenu/menuItem";

export interface ICustomerInvoiceParam {
  billingFrequency: string;
  invoiceType: string;
  paperlessStatus: string;
}

const YourBillingCycle = () => {
  const [displayBillingCycle, setDisplayBillingCycle] = useState(false);
  const [customerInvoiceParam, setCustomerInvoiceParam] = useState(
    {} as ICustomerInvoiceParam
  );

  useEffect(() => {
    let customerInvoiceParamsSub: Subscription | null;
    const billingCycleSub = MenuItemService.displayBillingCycle().subscribe(
      (value: boolean) => {
        setDisplayBillingCycle(value);

        if (value) {
          customerInvoiceParamsSub =
            ArService.getCustomerInvoiceParameters().subscribe(
              (customerInvoiceParam) => {
                setCustomerInvoiceParam(customerInvoiceParam);
              }
            );
        }
      }
    );

    return () => {
      billingCycleSub.unsubscribe();
      if (customerInvoiceParamsSub) {
        customerInvoiceParamsSub.unsubscribe();
      }
    };
  }, []);

  return (
    <>
      {displayBillingCycle && (
        <>
          <MenuItem
            icon="calendar_today"
            label="Your Billing Cycle"
            labelClass="font-weight-bold"
          />
          <div>
            {customerInvoiceParam && customerInvoiceParam.billingFrequency}
          </div>
        </>
      )}
    </>
  );
};

export default YourBillingCycle;
